module.exports = __webpack_public_path__ + "img/000083.10808839.png";